import { Box } from "@mui/material";
import WaitlistHeader from "./WaitlistHeader";
import { useWaitlist } from "./useWaitlist";
import Spinner from "../../shared/spinner/Spinner";
import Waitlist from "./Waitlist";

const WaitlistPage = () => {
  const {
    showWaitlist,
    isConfigLoading,
    toggleLoading,
    toggleWaitlist,
    listenToWaitlist,
    waitlist,
    waitlistLoading,
  } = useWaitlist();

  if (isConfigLoading) {
    return <Spinner />;
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <WaitlistHeader
        isWaitlistEnabled={showWaitlist}
        onToggle={toggleWaitlist}
        loading={toggleLoading}
        disabled={toggleLoading}
        totalWaiting={waitlist.length}
      />
      <Waitlist
        list={waitlist}
        loading={waitlistLoading}
        subscribeWaitlist={listenToWaitlist}
      />
    </Box>
  );
};

export default WaitlistPage;
